// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoomCallPopupContent__container-a67101 {
  display: flex;
  flex-direction: column;
  height: var(--app-height);
  min-height: 600px;
  background-color: var(--base-0);
  padding: 16px 32px;
  box-sizing: border-box;
  flex: 1;
}

.RoomCallPopupContent__header-b332c4 {
  margin-bottom: 56px;
}

.RoomCallPopupContent__logo-bc69b9 {
  width: 138px;
  height: 32px;
}

@media (min-width: 1440px) {
  .RoomCallPopupContent__container-a67101 {
    padding: 16px 56px;
  }
}
@media (max-width: 1024px) {
  .RoomCallPopupContent__header-b332c4 {
    margin-bottom: 0;
    align-items: center;
    display: flex;
    padding-bottom: 10px;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/components/RoomCallPopupContent/RoomCallPopupContent.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,sBAAA;EACA,OAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,kBAAA;EACF;AACF;AAEA;EACE;IACE,gBAAA;IACA,mBAAA;IACA,aAAA;IACA,oBAAA;IACA,uBAAA;EAAF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  height: var(--app-height);\n  min-height: 600px;\n  background-color: var(--base-0);\n  padding: 16px 32px;\n  box-sizing: border-box;\n  flex: 1;\n}\n\n.header {\n  margin-bottom: 56px;\n}\n\n.logo {\n  width: 138px;\n  height: 32px;\n}\n\n@media (min-width: 1440px) {\n  .container {\n    padding: 16px 56px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .header {\n    margin-bottom: 0;\n    align-items: center;\n    display: flex;\n    padding-bottom: 10px;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RoomCallPopupContent__container-a67101`,
	"header": `RoomCallPopupContent__header-b332c4`,
	"logo": `RoomCallPopupContent__logo-bc69b9`
};
module.exports = ___CSS_LOADER_EXPORT___;
